import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  APPLY_THERAPY_TEMPLATES_REQUEST_2_0,
  APPLY_THERAPY_TEMPLATES_SUCCESS_2_0,
  APPLY_THERAPY_TEMPLATES_FAILURE_2_0,
  APPLY_THERAPY_TEMPLATES_LOADING_2_0,
  APPLY_THERAPY_TEMPLATES_RESET_2_0,
} = therapyPlanningAction;

const intitialstate: object = {
  response: null,
  loading: false,
  isTemplateUpdated: false,
};

export const applyTheTherapyTemplatesReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case APPLY_THERAPY_TEMPLATES_SUCCESS_2_0: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isTemplateUpdated: true,
      };
    }

    case APPLY_THERAPY_TEMPLATES_FAILURE_2_0:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isTemplateUpdated: false,
      };
    case APPLY_THERAPY_TEMPLATES_LOADING_2_0:
      return {
        ...state,
        loading: true,
      };

    case APPLY_THERAPY_TEMPLATES_RESET_2_0:
      return intitialstate;

    default:
      return state;
  }
};
